var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.123 0.5C17.3435 0.5 19.5 2.761 19.5 6.124V13.8864C19.5 17.239 17.3435 19.5 14.123 19.5H5.8865C2.666 19.5 0.5 17.239 0.5 13.8864V6.124C0.5 2.761 2.666 0.5 5.8865 0.5H14.123ZM13.971 7.15C13.648 6.827 13.116 6.827 12.793 7.15L8.8695 11.0735L7.207 9.411C6.884 9.088 6.352 9.088 6.029 9.411C5.706 9.734 5.706 10.2565 6.029 10.589L8.29 12.8405C8.4515 13.002 8.6605 13.078 8.8695 13.078C9.088 13.078 9.297 13.002 9.4585 12.8405L13.971 8.328C14.294 8.005 14.294 7.4825 13.971 7.15Z",
    fill: "#009364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptChat);
export default __webpack_public_path__ + "static/media/accept-chat.c7001fa1f5a09f6105b1f2c5b1cd3f98.svg";
export { ForwardRef as ReactComponent };